export default {
    card:{
        // width: 1320,
        display: 'flex',
        justifyContent: 'center',
        height: 470,
        // overflow: 'auto'
    },
}
